export default __webpack_public_path__ + "c1a062b0e64d6401b434a251bed25696.svg";